import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Autocomplete,
  FormGroup,
  Switch,
  Modal,
  Card,
} from "@mui/material";
import CustomTable from "../../components/table/Table";
import { useDispatch, useSelector } from "react-redux";
import SearchButton from "../../components/search/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUpload from "../../components/button/Cloudupload";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getregion } from "../../slices/setting";
import { createcustomer, createinvoice, createpayment, getinvoicebycus, getinvoicebyid, getpaymentbycus, getpaymentbyid, updateinvoicebyid } from "../../slices/customer";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getpurchase } from "../../slices/purchase";
import BasicTabs from "../../components/tabs/Invitab";
import { deleteproductstock, getproductstock } from "../../slices/inventory";
import DeleteIcon from "@mui/icons-material/Delete";
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import CustomTable2 from "../../components/table/paytable";
import { useReactToPrint } from 'react-to-print';
import { getchallanbyid } from "../../slices/challan";

const columns2 = [
  { id: 'payment_id', label: 'Payment ID', minWidth: 200, align:'start' },
  { id: 'invoice_id', label: 'Invoice ID', minWidth: 150, align:'center' },
  { id: 'total', label: 'Amount', minWidth: 150, align:'center' },
  { id: 'status', label: 'Status', minWidth: 150, align:'center' },
  // { id: 'action', label: 'Action', minWidth: 100, align:'end', actionType: [{edit: true, delete: false}] },
];


const Viewchallan = ({ setLoader, show }) => {

  const componentRef = useRef();

  const params = useParams()

  const {getChallan: paymentData} = useSelector((state) => state.challan) || [];

  const user = JSON.parse(localStorage.getItem('user'));

  const dealerState =  JSON.parse(user.billing_address).state; 


  const dispatch = useDispatch();

  const navigate = useNavigate();

  const arrowBack = () => {
    navigate(-1);
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  React.useEffect(()=>{
    setLoader(true)
    const c_id = params.challanId;
      dispatch(getchallanbyid(c_id))
      .then(() => {
        setLoader(false);
      })
      .catch(()=>{
        setLoader(false);
      })
  }, [])

  return (
    <div className="content" style={{ marginLeft: show ? "220px" : "10px", marginBottom:'150px'}}>
    <Grid container spacing={2}>
    <Grid
            item
            xs={6}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >

            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5">{params.invoiceId}</Typography>
          </Grid>
          <Grid
            item
            xs={6}
            onClick={handlePrint}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              justifyContent:'end',
              gap: 1,
            }}
          >
            <LocalPrintshopOutlinedIcon sx={{ cursor: "pointer" }} />
            <Typography variant="h6">Print</Typography>
          </Grid>
    </Grid>
      <Box ref={componentRef} sx={{mt: 2, border:'1px solid #bababa', p: 3}}>
        <Grid container spacing={3} sx={{ paddingBottom: 2, alignItems: "center" }}>
        <Grid item xs={6} sx={{display:'flex', alignItems:'center', justifyContent:'start', gap: 2}}>
                <Typography><img src={user?.logo_url} width={100}></img></Typography>
                <Box>
                <Typography variant="h6">{user.organization_name}</Typography>
                <Typography >{Object.values(JSON.parse(user?.billing_address)).join(', ')}</Typography>
                <Typography >{user.contact}</Typography>
                </Box>
            </Grid>
        <Grid item xs={6} sx={{textAlign:'end'}}>
                <Typography variant="h6">Delivery Challan</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={6}>
                <Typography >Billed to</Typography>
                <Typography variant="h6">{paymentData[0]?.dealer_name}</Typography>
                <Typography variant="h6">{paymentData[0]?.challan_type}</Typography>
                </Grid>
                <Grid item xs={6}  sx={{textAlign:'end'}}>
                <Typography >Date: {paymentData[0]?.delivery_challan_date}</Typography>
                <Typography >Reference # : {paymentData[0]?.reference}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                <Grid item xs={12}>
        {paymentData[0]?.items ? 
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} sx={{background:'#595959', color:'#fff'}}>Items</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>HSN</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Price</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>SGST</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>CGST</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>IGST</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {paymentData[0]?.items && JSON.parse(paymentData[0]?.items).map((va, index) => {
          return(
            <TableRow key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                         {(va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ?
              <TableCell component="th" scope="row">
            {va?.vehicle?.product_name} <br></br>
Vehicle Model: {va?.variant?.variant_name} <br/>

Vehicle Color: {JSON.parse(va?.variant?.color_details).filter(obj => obj.code === va?.stock?.color)[0]?.name} <br/>

Chassis No: {va?.stock?.chasis_no} <br/>

Motor name: {va?.variant?.motor_name} <br/>

Motor No: {va?.stock?.motor_no} <br/>

Motor type: {va?.variant?.motor_type} <br/>

Motor warranty: {va?.variant?.motor_warranty_months}  <br/>

Battery name: {va?.variant?.battery_name} <br/>

Battery number: {va?.stock?.battery_no} <br/>

Battery type: {va?.variant?.battery_type} <br/>

Battery warranty: {va?.variant?.battery_warranty_months}  <br/>

Charger name: {va?.variant?.charger_name} <br/>

Charger type: {va?.variant?.charger_type} <br/>

Charger capacity: {va?.variant?.charger_capacity} <br/>

Charger warranty: {va?.variant?.charger_warranty_months}  <br/>

Controller No: {va?.stock?.controller_no} <br/>

Converter No: {va?.stock?.convertor_no} <br/>
              </TableCell>
              :
              <TableCell component="th" scope="row">
            {va?.vehicle?.product_name} <br></br>
Vehicle Model: {va?.variant?.variant_name} <br/>

Product Name: {va?.stock?.product} <br/>

Company: {va?.stock?.company} <br/>

Part Code: {va?.stock?.part_code} <br/>
              </TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
              <TableCell >{va?.vehicle?.hsn_no}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{va?.spare?.hsn_no}</TableCell>
              :
              <TableCell >{va?.accessory?.hsn_no}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{va?.spare?.price}</TableCell>
              :
              <TableCell >{va?.accessory?.price}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.sgst !== 0 ? (va.vehicle?.sgst) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va.spare?.sgst) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va.accessory?.sgst) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.sgst !== 0 ? (JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom * (va.vehicle?.sgst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.spare?.price * (va.spare?.sgst/100)) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.accessory?.price * (va.accessory?.sgst/100)) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.cgst !== 0 ? (va.vehicle?.cgst) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va.spare?.cgst) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va.accessory?.cgst) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.cgst !== 0 ? (JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom * (va.vehicle?.cgst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va?.spare?.price * (va.spare?.cgst/100)) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.cgst !== 0 ? (va?.accessory?.price * (va.accessory?.cgst/100)) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.igst !== 0 ? (va.vehicle?.igst) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.igst !== 0 ? (va.spare?.igst) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.igst !== 0 ? (va.accessory?.igst) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type")) ? 
            <TableCell >{paymentData[0]?.igst !== 0 ? (JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom * (va.vehicle?.igst/100)) : '-'}</TableCell>
              :
              va?.product_type === "Spare" ?
              <TableCell >{paymentData[0]?.igst !== 0 ? (va?.spare?.price * (va.spare?.igst/100)) : '-'}</TableCell>
              :
              <TableCell >{paymentData[0]?.igst !== 0 ? (va?.accessory?.price * (va.accessory?.igst/100)) : '-'}</TableCell>
            }
            { (va?.product_type === "Vehicle" || !va.hasOwnProperty("product_type"))? 
            <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom)+Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom * (va.vehicle?.sgst/100))+Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom * (va.vehicle?.cgst/100))+Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom * (va.vehicle?.igst/100))) : Number(JSON.parse(va.variant?.price_groups).filter(obj => obj.state === dealerState)[0]?.ex_showroom)}</TableCell>             :
              va?.product_type === "Spare" ?
              <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(va?.spare?.price)+Number((va?.spare?.price) * (va?.spare?.sgst/100))+Number((va?.spare?.price) * (va?.spare?.cgst/100))+Number((va?.spare?.price) * (va?.spare?.igst/100))) : Number(va?.spare?.price)}</TableCell>
                :
                <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(va?.accessory?.price)+Number((va?.accessory?.price) * (va?.accessory?.sgst/100))+Number((va?.accessory?.price) * (va?.accessory?.cgst/100))+Number((va?.accessory?.price) * (va?.accessory?.igst/100))) : Number(va?.accessory?.price)}</TableCell>            }
              
            </TableRow>
          )
        })}
        </TableBody>
      </Table>
      :
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} sx={{background:'#595959', color:'#fff'}}>Item Details</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>HSN</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Rate</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Discount</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Discount Amount</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>SGST</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>CGST</TableCell>
            <TableCell colSpan={2} align="center" sx={{background:'#595959', color:'#fff'}}>IGST</TableCell>
            <TableCell rowSpan={2} align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
            <TableCell sx={{background:'#595959', color:'#fff'}}>%</TableCell>
            <TableCell align="right" sx={{background:'#595959', color:'#fff'}}>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {paymentData[0]?.items && JSON.parse(paymentData[0]?.items).map((va, index) => {
          return(
            <TableRow key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              {va?.service_name}
              </TableCell>
              <TableCell >{va?.hsn_no}</TableCell>
              <TableCell >{va?.price}</TableCell>
              <TableCell >{va?.discount}</TableCell>
              <TableCell >{va.price * (Number(va?.discount) /100)}</TableCell>
              <TableCell >{paymentData[0]?.sgst !== 0 ? (va?.sgst || 0) : '-'}</TableCell>
              <TableCell >{paymentData[0]?.sgst !== 0 ? va.price * (va?.sgst || 0 /100) : '-'}</TableCell>
              <TableCell >{paymentData[0]?.cgst ? (va?.cgst || 0) : '-'}</TableCell>
              <TableCell >{paymentData[0]?.cgst ? va.price * (va?.cgst || 0/100) : '-'}</TableCell>
              <TableCell >{paymentData[0]?.igst ? (va?.igst || 0) : '-'}</TableCell>
              <TableCell >{paymentData[0]?.igst ? va.price * (va?.igst || 0/100) : '-'}</TableCell>
              <TableCell >{(paymentData[0]?.sgst !== 0 || paymentData[0]?.cgst !== 0 || paymentData[0]?.igst !== 0) ? (Number(va?.price)+Number(va?.price * (va?.sgst || 0/100))+Number(va.price * (va?.cgst || 0/100))+Number(va.price * (va?.igst || 0/100))-Number(va.price * (Number(va?.discount) /100))) : Number(va?.price)}</TableCell>
              
            </TableRow>
          )
        })}
        </TableBody>
      </Table>
                }
                </Grid>
                <Grid item xs={12}>
                <Divider sx={{mb: 2}}/>           
                </Grid>
            <Grid item xs={6}>
            <Typography >Customer Notes</Typography>
                <Typography >{paymentData[0]?.customer_notes}</Typography>
            </Grid>
            <Grid item xs={6} sx={{p: 2, background:'#eaeaea', textAlign:'end'}}>
            <Grid container spacing={2}>
          <Grid item xs={9} sx={{textAlign:'end'}}>
              <Typography variant="body1" sx={{mb: 1}}>Sub Total</Typography>
              <Typography  variant="body1"  sx={{mb: 1}}>Adjustment</Typography>
              <Typography  variant="h6">Total Amount</Typography>
          </Grid>
          <Grid item xs={3} sx={{textAlign:'end'}}>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.sub_total}</Typography>
              <Typography variant="body1" sx={{mb: 1}}>₹ {paymentData[0]?.adjustment}</Typography>
              <Typography variant="h6">₹ {paymentData[0]?.total_price}</Typography>
          </Grid>
    </Grid>
            </Grid>
        </Grid>
        <Divider sx={{mb: 2}}/>           
        <Grid container sx={{p: 2, pb: 8, background:'#eaeaea'}}>
                  <Grid item xs={6}>
                  <Typography>Signature customer</Typography>
            </Grid>
            <Grid item xs={5} sx={{textAlign:'end'}}>
            <Typography>Signature authority</Typography>
                </Grid>
            </Grid>
      </Box>
    </div>
  );
};

export default Viewchallan;